export const UserandGroups = (props: any) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_480_4681)">
      <path
        d="M21.0397 12.873H19.1836C19.3728 13.391 19.4761 13.95 19.4761 14.5326V21.5475C19.4761 21.7904 19.4339 22.0235 19.3569 22.2404H22.4254C23.5717 22.2404 24.5042 21.3078 24.5042 20.1617V16.3375C24.5042 14.4272 22.95 12.873 21.0397 12.873Z"
        fill="#5C5C5C"
      />
      <path
        d="M5.52806 14.5326C5.52806 13.95 5.63142 13.391 5.8206 12.873H3.96454C2.05419 12.873 0.5 14.4272 0.5 16.3376V20.1617C0.5 21.3079 1.43249 22.2404 2.57872 22.2404H5.64726C5.57034 22.0235 5.52806 21.7904 5.52806 21.5475V14.5326Z"
        fill="#5C5C5C"
      />
      <path
        d="M14.6218 11.0684H10.3786C8.46825 11.0684 6.91406 12.6225 6.91406 14.5329V21.5478C6.91406 21.9304 7.22428 22.2407 7.60697 22.2407H17.3935C17.7761 22.2407 18.0864 21.9304 18.0864 21.5478V14.5329C18.0864 12.6225 16.5322 11.0684 14.6218 11.0684Z"
        fill="#5C5C5C"
      />
      <path
        d="M12.5025 1.88086C10.205 1.88086 8.33594 3.74996 8.33594 6.04745C8.33594 7.60581 9.19605 8.96683 10.4663 9.68139C11.0688 10.0203 11.7634 10.214 12.5025 10.214C13.2416 10.214 13.9362 10.0203 14.5387 9.68139C15.809 8.96683 16.669 7.60576 16.669 6.04745C16.669 3.75 14.7999 1.88086 12.5025 1.88086Z"
        fill="#5C5C5C"
      />
      <path
        d="M5.18243 5.76562C3.46422 5.76562 2.06641 7.16344 2.06641 8.88165C2.06641 10.5999 3.46422 11.9977 5.18243 11.9977C5.61827 11.9977 6.0333 11.9074 6.41032 11.7451C7.06217 11.4645 7.59964 10.9677 7.93221 10.3454C8.16565 9.90868 8.29845 9.41044 8.29845 8.88165C8.29845 7.16349 6.90063 5.76562 5.18243 5.76562Z"
        fill="#5C5C5C"
      />
      <path
        d="M19.8191 5.76562C18.1009 5.76562 16.7031 7.16344 16.7031 8.88165C16.7031 9.41049 16.8359 9.90873 17.0694 10.3454C17.4019 10.9677 17.9394 11.4645 18.5913 11.7451C18.9683 11.9074 19.3833 11.9977 19.8191 11.9977C21.5374 11.9977 22.9352 10.5999 22.9352 8.88165C22.9352 7.16344 21.5374 5.76562 19.8191 5.76562Z"
        fill="#5C5C5C"
      />
    </g>
    <defs>
      <clipPath id="clip0_480_4681">
        <rect width="24" height="24" fill="white" transform="translate(0.5 0.0605469)" />
      </clipPath>
    </defs>
  </svg>
);
